export const CALENDLY_PAGE_SETTINGS = {
  backgroundColor: '0f1a11',
  textColor: 'ffffff',
  primaryColor: '2563eb',
};

function buildCalendlyUrl() {
  const url = new URL(import.meta.env.VITE_CALENDLY_URL);
  url.searchParams.set('background_color', CALENDLY_PAGE_SETTINGS.backgroundColor);
  url.searchParams.set('text_color', CALENDLY_PAGE_SETTINGS.textColor);
  url.searchParams.set('primary_color', CALENDLY_PAGE_SETTINGS.primaryColor);

  return url.toString();
}

/** Calendly booking URL with theme colors baked in, for use in plain links (new tab). */
export const CALENDLY_LINK_URL = buildCalendlyUrl();
